import React from "react";
import './Containers.css'
import {ViewSelectorButton} from "./Controllers"
import {EAppView} from "./App"
import {SessionsView} from "./Sessions"
import {ZonesView} from "./Zones";
import {QuestionsView} from "./Questions";

function ViewContainer(props) {
    switch (props.view) {
        case EAppView.Sessions:
            return <div className="ViewContainer"><SessionsView changeView={props.changeView}
                                                                sessions={props.sessions}/></div>;
        case EAppView.Zones:
            return <div className="ViewContainer"><ZonesView refreshZones={props.refreshZones}
                                                             changeView={props.changeView}/></div>;
        case EAppView.Questions:
            return <div className="ViewContainer"><QuestionsView refreshQuestions={props.refreshQuestions}
                                                                 changeView={props.changeView}/></div>;
        default:
            return <div className="ViewContainer"/>;
    }
}

function ViewSelector(props) {
    const view = props.view;
    return (
        <div className="ViewSelector">
            <ViewSelectorButton changeView={props.changeView}
                                selected={view === EAppView.Sessions}
                                view={EAppView.Sessions}/>
            <ViewSelectorButton changeView={props.changeView}
                                selected={view === EAppView.Questions}
                                view={EAppView.Questions}/>
            <ViewSelectorButton changeView={props.changeView}
                                selected={view === EAppView.Zones}
                                view={EAppView.Zones}/>
        </div>
    );
}

function InfoListButton(props) {
    return <button onClick={props.onClick} className="InfoListButton">{props.info}</button>;
}

export {ViewContainer, ViewSelector, InfoListButton};